import {isEmpty as _isEmpty} from 'lodash';
import {withRouter} from 'react-router';

import {refetchQueryByName} from '@utils/apollo';
import {WORKING_REPORT_TYPE} from '@constants/variables';

import {EventReportIncidentForm} from './EventReportIncidentForm';

class EventReportBasicForm extends EventReportIncidentForm {
    componentDidMount() {
        this.setCreateSuccessCallback(() => {
            refetchQueryByName('ReportState');
            refetchQueryByName('GetReports');
        });
        this.setDeleteSuccessCallback(() => {
            refetchQueryByName('ReportState');
        });
        this.setUpdateSuccessCallback(() => {
            refetchQueryByName('ReportState');
        });
        this.getScopeTreeOptions(false);

        if ((!this.props.formParams.id && !this.props.formParams.isReportsTableEmpty)
            || (this.props.formParams.id && !this.props.formParams.isEditingOnlyOwnReport)) {
            this.setField('includes_all_streams', {
                hidden: true,
                defaultValue: false,
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);

        this.handleReportScopesVisibility(this.props.formValues, prevProps);

        if (_isEmpty(this.props.formValues.report_scopes) && prevState.scopeTreeOptions !== this.state.scopeTreeOptions) {
            this.setField('report_scopes', {options: this.createTreeOptions(this.state.scopeTreeOptions)});
        }

        if (this.props.formParams.reportType === WORKING_REPORT_TYPE
            && !this.props.formParams.id
            && this.state.scopeTreeOptions !== prevState.scopeTreeOptions
            && !this.state.allScopesSelectedByDefault) {
            const allSelected = this.state.scopeTreeOptions.map(eventContent => ({
                ...eventContent,
                distributions: eventContent.distributions.map(distribution => ({
                    ...distribution,
                    stream_variants: distribution.stream_variants.map(variant => ({
                        ...variant,
                        selected: true,
                    })),
                })),
            }));
            this.setState({
                scopeTreeOptions: allSelected,
                allScopesSelectedByDefault: true,
            });
        }
    }

    prepareDataForSubmit = (data) => {
        let dataToSave = {
            comment: data.comment ?? '',
            incident_source: null,
            incident_type: null,
            incident_duration: null,
            incident_duration_unit: null,
            count_as_downtime: null,
            includes_all_streams: data.includes_all_streams,
            report_scopes: data.includes_all_streams ? [] : this.transformScopeToReportScopes(data.report_scopes),
            event: this.props.formParams.event,
            report_type: this.props.formParams.reportType,
        };

        if (this.props.formParams.id) {
            dataToSave.id = this.props.formParams.id;
        }

        return dataToSave;
    };
}

export default withRouter(EventReportBasicForm);
